import React from 'react';
import { Box, Typography, Link, Grid } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

export default function Footer() {
  return (
    <Box
      component="footer"
      sx={{
        mt: 8,
        py: 4,
        backgroundColor: 'background.paper',
        borderTop: 1,
        borderColor: 'divider',
        textAlign: 'center',
      }}
    >
      <Grid container spacing={2} justifyContent="center">
        <Grid item>
          <Link component={RouterLink} to="/terms" underline="hover">
            Terms & Conditions
          </Link>
        </Grid>
        <Grid item>
          <Link component={RouterLink} to="/privacy" underline="hover">
            Privacy Policy
          </Link>
        </Grid>
        <Grid item>
          <Link component={RouterLink} to="/refund" underline="hover">
            Refund Policy
          </Link>
        </Grid>
        <Grid item>
          <Link component={RouterLink} to="/about" underline="hover">
            About Us
          </Link>
        </Grid>
        <Grid item>
          <Link component={RouterLink} to="/contact" underline="hover">
            Contact Us
          </Link>
        </Grid>
      </Grid>

      <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
        &copy; {new Date().getFullYear()} HPHT Vending. All rights reserved.
      </Typography>
    </Box>
  );
}